var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagInCircle = function SvgTagInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DFE8F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.39 20c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z",
    fill: "#004996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.21 27.22-1.4-1.4 4-4-4-4 1.4-1.4 5.4 5.4-5.4 5.4z",
    fill: "#9FC752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.6 20.41 1.4 1.4-4 4 4 4-1.4 1.4-5.4-5.4 5.4-5.4z",
    fill: "#D64309"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.51 29.95c-.35.11-.74.03-1-.24l-9.12-9.12V12h8.59l4.49 4.48 1.41-1.41L20.8 10H9.39v11.41l9.71 9.71c.58.58 1.35.87 2.13.87.55 0 1.11-.15 1.6-.46.06-.04.11-.08.16-.12l-1.47-1.47-.01.01z",
    fill: "#004996"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTagInCircle;